import { useContext } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

import { HeadTagContext } from '../../context/HeadTagProvider';
import { AccountSubscriptionHeader } from '../pages/lp/organisms/accountSubscription/AccountSubscriptionHeader';
import { useMetaData } from '../../common/customHooks/MetaReplace';

interface SubscriptionLayoutProps {
  metaTitle: string;
  metaDescription?: string;
  onClickCv?: () => void;
}

export const SubscriptionLayout: React.FC<SubscriptionLayoutProps> = ({
  metaTitle,
  metaDescription,
  children,
  onClickCv,
}) => {
  const headTagContext = useContext(HeadTagContext);

  useMetaData(metaTitle, metaDescription);

  return (
    <>
      <Helmet title={headTagContext.title} meta={headTagContext.meta} />
      <Wrapper>
        <AccountSubscriptionHeader onClickCv={onClickCv} />
        <main>{children}</main>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
